// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".img img{-o-object-fit:cover;object-fit:cover}.whitespace{white-space:nowrap}.pulsate{-webkit-animation:pulsate 2s ease-out;-webkit-animation-iteration-count:infinite}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
